// Module
var code = "<h2 id=\"loan-forgiveness--discharge\">Loan Forgiveness &amp; Discharge</h2> <p>See if you qualify to have your loan debt reduced or eliminated, depending on your professional or personal situation.</p> ";
// Exports
export default code;